import React from "react";
import Heading from "../../components/common/Typography/Heading";
import SpecialText from "../../components/common/Typography/SpecialText";
import Paragraph from "../../components/common/Typography/Paragraph";
import MovingLeft from "../../components/common/FullLengthSwipers/MovingLeft";
import MovingRight from "../../components/common/FullLengthSwipers/MovingRight";
import { Rating } from "primereact/rating";

const UserReviews = () => {
  const reviews = [
    {
      name: "John",
      trade: "Carpenter",
      review: "Booked steady carpentry work for months. No chasing, just jobs. Customers find me directly and I can focus on what I do best - quality craftsmanship."
    },
    {
      name: "Maria",
      trade: "Painter",
      review: "Painting gigs lined up week after week. Couldn't be simpler. The platform connects me with serious customers who value professional work."
    },
    {
      name: "Dave",
      trade: "Electrician",
      review: "Best way to keep my electrical jobs flowing. I've built a solid reputation here and customers keep coming back for more work."
    },
    {
      name: "Sarah",
      trade: "Plumber",
      review: "Finally, a platform that gets it. No more cold calling or expensive ads. Quality customers find me and I set my own rates."
    },
    {
      name: "Mike",
      trade: "Handyman",
      review: "From small fixes to major renovations, I'm booked solid. The reviews help customers trust me and I get repeat business."
    },
    {
      name: "Lisa",
      trade: "Landscaper",
      review: "My garden designs speak for themselves, but this platform helps customers find me. Steady work all season long."
    },
    {
      name: "Tom",
      trade: "Roofer",
      review: "Weather-dependent work is tough, but this platform keeps me busy year-round. Customers appreciate the direct contact."
    },
    {
      name: "Emma",
      trade: "Tiler",
      review: "Specialized work like mine needs the right customers. This platform brings them to me with detailed project descriptions."
    }
  ];

  const ReviewCard = ({ name, trade, review }) => (
    <div className="bg-white rounded-xl flex flex-col items-center p-5 w-[300px] h-auto lg:w-[400px] lg:h-[200px]">
      <div className="flex w-full">
        <div className="size-10 lg:size-12">
          <img
            className="size-10 lg:size-12 object-cover rounded-full"
            src={require("../../assets/img/User.png")}
            alt="user"
          />
        </div>
        <div className="flex-1 ml-3 lg:ml-5">
          <SpecialText variant={"ProfileName"} className={"mt-1 lg:mt-2"}>
            {name}
          </SpecialText>
          <div className="mt-1">
            <SpecialText variant="ProfileMeta">
              {trade}
            </SpecialText>
          </div>
        </div>
      </div>
      <div className="mt-3 w-full">
        <div>
          <Paragraph
            variant={"BodyDense"}
            className={
              "h-[50px] sm:h-[39px] md:h-[58px] pb-1 overflow-hidden text-ellipsis text-offblack"
            }
          >
            {review}
          </Paragraph>
        </div>
        <div className="flex items-center justify-between mt-3">
          <div className="flex items-center gap-1">
            <Rating
              value={5}
              stars={1}
              style={{ gap: 5 }}
              cancel={false}
              readOnly={true}
            />
            <SpecialText variant={"Counter"}>5.0</SpecialText>
          </div>
          <SpecialText variant={"DateStamp"} className={"text-offblack"}>
            1 m ago
          </SpecialText>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="mx-[5%] xl:mx-auto xl:w-[1100px] 2xl:w-[1264px] mt-10 sm:mt-40">
        <Heading variant={"h2"} className={"text-center text-offblack"}>
          Real tradies. Real work.
        </Heading>
      </div>
      <div className="mt-5 sm:mt-20">
        <MovingLeft speed={"100s"}>
          {reviews.map((review, index) => (
            <div className="sliderImg" key={index}>
              <div className="cursor-pointer m-2 sm:m-4">
                <ReviewCard 
                  name={review.name}
                  trade={review.trade}
                  review={review.review}
                />
              </div>
            </div>
          ))}
        </MovingLeft>
        <MovingRight speed={"100s"}>
          {reviews.map((review, index) => (
            <div className="sliderImg" key={index}>
              <div className="cursor-pointer m-2 sm:m-4">
                <ReviewCard 
                  name={review.name}
                  trade={review.trade}
                  review={review.review}
                />
              </div>
            </div>
          ))}
        </MovingRight>
      </div>
    </>
  );
};

export default UserReviews;
